import styles from "./PhotographersGrid.module.css"
import { getAllPhotographers } from "../../../app/lib/prisma-db.js"
import Image from "next/image";
import Link from "next/link";

export default async function PhotographersGrid(){
    const photographers = await getAllPhotographers();
    
    return(
        <section className={styles.photographersGrid}>
            {photographers.map((photographer) => {
                let url = "/photographer/" + photographer.id + "-" + slugify(photographer.name);

                return(
                    <article key={photographer.id} className={styles.photographer}>
                        <Link href={url} style={{ textDecoration: 'none' }}>
                            <div className={styles.photographerHeader}>
                                <Image 
                                    src = {"/assets/" + photographer.portrait}
                                    width={200}
                                    height={200}
                                    alt={photographer.name}
                                    className={styles.portrait}
                                />
                                <h2 className={styles.name}>{photographer.name}</h2>
                            </div>
                        </Link>
                        <div className={styles.photographerContent}>
                            <p className={styles.location}>{photographer.city}, {photographer.country}</p>
                            <p className={styles.tagline}>{photographer.tagline}</p>
                            <p className={styles.price}>{photographer.price}€/jour</p>
                        </div>
                    </article>
                )
            })}
        </section>
    )
}

function slugify(name) {
  return name
    .toLowerCase()
    .replace(/ /g, "_");
}